import { Choice, Entity, ID, Package } from "../types";

interface PersistedState {
  lastModified: string;
  appVersion: string;
  choices: Entity<Choice>;
  hidden: ID[];
  disabled: ID[];
  packaged: Entity<Package>;
}

export const saveState = (key: string, state: PersistedState) => {
  try {
    const stringified = JSON.stringify(state);
    localStorage.setItem(key, stringified);
  } catch (err) {
    console.log(err);
  }
};

export const loadState = (
  key: string,
  lastModified: string,
  appVersion: string
) => {
  try {
    const stringified = localStorage.getItem(key);
    if (!stringified) return;
    const state = JSON.parse(stringified);

    const pastModifiedTimestamp = state.lastModified;
    const currentModifiedTimestamp = lastModified;

    const pastVersion = state.appVersion;
    const currentVersion = appVersion;

    if (pastModifiedTimestamp !== currentModifiedTimestamp) {
      localStorage.removeItem(key);
      return;
    }
    if (pastVersion !== currentVersion) {
      localStorage.removeItem(key);
      return;
    }
    return {
      choices: state.choices,
      hidden: state.hidden,
      disabled: state.disabled,
      packaged: state.packaged,
    };
  } catch (err) {
    return;
  }
};
